<template>
  <div class="create-comment-query">
    <div
      class="create-comment-donation__info-box"
      v-if="showFundInformation && !donation"
    >
      <span class="donation-form__donation">
        <svg aria-hidden="true" class="icon">
          <use href="#hand-holding-heart" />
        </svg>
        {{ texts.singleComment.hasDonated }}
      </span>
      <p class="create-comment-donation__info-text">
        {{
          sprintf(
            texts.createComment.donationInfoQuery,
            orderInfo.possessiveName
          )
        }}
      </p>
    </div>

    <div class="create-comment-query__container">
      <div
        class="obituary-comments__submit-container create-comment-query__actions"
      >
        <button
          class="btn btn-cta"
          type="button"
          v-if="!(showFundInformation && donation)"
          @click.prevent="next()"
          v-text="acceptText"
        />

        <button class="btn outline" type="button" @click.prevent="preview()">
          <span v-text="previewText" />
        </button>
      </div>

      <template v-if="showFundInformation">
        <div class="obituary-comments__fund-information">
          <create-comment-fund-information
            v-if="!!orderInfo.memorialFund"
            :memorial-fund="orderInfo.memorialFund"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { sprintf } from "sprintf-js";
  import { mapActions, mapState } from "vuex";
  import { DONATION_QUERY, PREVIEW } from "../../createCommentStepsHelper";
  import CreateCommentFundInformation from "./CreateCommentFundInformation.vue";

  export default {
    components: { CreateCommentFundInformation },

    computed: {
      ...mapState("createComment", ["modalContext"]),
      ...mapState("donations", ["donation"]),

      acceptText() {
        if (this.modalContext === this.DONATION_QUERY) {
          return this.texts.common.donate;
        }

        return this.texts.createComment.proceedCta;
      },

      previewText() {
        return this.donation
          ? this.texts.createComment.proceedCta
          : this.texts.createComment.continueWithoutGift;
      },

      showFundInformation() {
        return this.modalContext === this.DONATION_QUERY;
      },
    },

    data() {
      return {
        DONATION_QUERY,
        texts: lavendlaObituary,
      };
    },

    methods: {
      sprintf,
      ...mapActions("createComment", [
        "nextStep",
        "addPrevContext",
        "changeModalContext",
      ]),

      next() {
        this.addPrevContext(this.modalContext);
        this.nextStep();
      },

      preview() {
        this.addPrevContext(this.modalContext);
        this.changeModalContext(PREVIEW);
      },
    },
    name: "CreateCommentQuery",

    props: {
      orderInfo: {
        default: null,
        type: Object,
      },
    },
  };
</script>
